<template>
  <v-container fluid>
    <v-toolbar color="indigo" dense class="rounded rounded-b-0 mt-5">
      <v-toolbar-title class="white--text"> Calendario </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-row align="center" justify="center">
        <v-col cols="2" class="px-0">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="px-2"
                @click="selezione = 'treeview'"
                v-bind="attrs"
                v-on="on"
                style="color: #0275d8"
                :disabled="selezione == 'treeview'"
                :style="{
                  color: '#0275d8',
                  outline:
                    selezione == 'treeview' ? 'solid 3px #0275d8' : 'none',
                }"
              >
                <v-icon class="mr-5">mdi-file-tree</v-icon> Calendari
              </v-btn>
            </template>
            <span>Calendari</span>
          </v-tooltip>
        </v-col>
        <v-col cols="2" class="px-0">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="selezione = 'azienda'"
                v-bind="attrs"
                v-on="on"
                style="color: #0275d8"
                :disabled="selezione == 'azienda'"
                :style="{
                  color: '#0275d8',
                  outline:
                    selezione == 'azienda' ? 'solid 3px #0275d8' : 'none',
                }"
              >
                <v-icon class="mr-5">mdi-factory</v-icon> Azienda
              </v-btn>
            </template>
            <span>Azienda</span>
          </v-tooltip>
        </v-col>
        <v-col cols="2" justify="center" class="px-0">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="selezione = 'sedi'"
                v-bind="attrs"
                v-on="on"
                style="color: #0275d8"
                :disabled="selezione == 'sedi'"
                :style="{
                  color: '#0275d8',
                  outline: selezione == 'sedi' ? 'solid 3px #0275d8' : 'none',
                }"
              >
                <v-icon class="mr-5">mdi-view-grid-outline</v-icon> Sedi
              </v-btn>
            </template>
            <span>Sedi</span>
          </v-tooltip>
        </v-col>
        <v-col cols="2" class="px-0">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="selezione = 'reparto'"
                v-bind="attrs"
                v-on="on"
                style="color: #0275d8"
                :disabled="selezione == 'reparto'"
                :style="{
                  color: '#0275d8',
                  outline:
                    selezione == 'reparto' ? 'solid 3px #0275d8' : 'none',
                }"
              >
                <v-icon class="mr-5">mdi-store-cog</v-icon> Reparti
              </v-btn>
            </template>
            <span>Reparti</span>
          </v-tooltip>
        </v-col>
        <v-col cols="2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                disabled
                @click="selezione = 'profili'"
                v-bind="attrs"
                v-on="on"
                style="color: #0275d8"
              >
                <v-icon class="mr-5">mdi-account-group</v-icon> Profili
              </v-btn>
            </template>
            <span>Profili</span>
          </v-tooltip>
        </v-col>
        <v-col cols="2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="selezione = 'macchine'"
                v-bind="attrs"
                v-on="on"
                style="color: #0275d8"
                :disabled="selezione == 'macchine'"
                :style="{
                  color: '#0275d8',
                  outline:
                    selezione == 'macchine' ? 'solid 3px #0275d8' : 'none',
                }"
              >
                <v-icon class="mr-5">mdi-robot-industrial</v-icon> Macchine
              </v-btn>
            </template>
            <span>Macchine</span>
          </v-tooltip>
        </v-col>
        <v-col cols="2" class="px-0">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="selezione = 'veicoli'"
                v-bind="attrs"
                v-on="on"
                style="color: #0275d8"
                :disabled="selezione == 'veicoli'"
                :style="{
                  color: '#0275d8',
                  outline:
                    selezione == 'veicoli' ? 'solid 3px #0275d8' : 'none',
                }"
              >
                <v-icon class="mr-5">mdi-truck</v-icon> VEICOLI
              </v-btn>
            </template>
            <span>Veicoli</span>
          </v-tooltip>
        </v-col>
        <v-col cols="2" class="px-0">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="selezione = 'autisti'"
                v-bind="attrs"
                v-on="on"
                style="color: #0275d8"
                :style="{
                  color: '#0275d8',
                  outline:
                    selezione == 'autisti' ? 'solid 3px #0275d8' : 'none',
                }"
                :disabled="selezione == 'autisti'"
              >
                <v-icon class="mr-5">mdi-account</v-icon> AUTISTI
              </v-btn>
            </template>
            <span>Autisti</span>
          </v-tooltip>
        </v-col>
        <v-col cols="2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="selezione = 'persone'"
                v-bind="attrs"
                v-on="on"
                :style="{
                  color: '#0275d8',
                  outline:
                    selezione == 'persone' ? 'solid 3px #0275d8' : 'none',
                }"
                :disabled="selezione == 'persone'"
              >
                <v-icon class="mr-5">mdi-account</v-icon> Persone
              </v-btn>
            </template>
            <span>Persone</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row justify="center" v-if="selezione == 'treeview'">
        <v-col cols="12" class="py-0">
          <QLCalTreeview @changeComponent="changeComponent" /> </v-col
      ></v-row>
      <v-row justify="center" v-if="selezione == 'azienda'">
        <v-col cols="12" class="py-0"> <AziendaCal /> </v-col
      ></v-row>
      <v-row justify="center" v-if="selezione == 'reparto'">
        <v-col cols="12" class="py-0">
          <RepartiCal
            :id_azienda_sede_reparto="id_azienda_sede_reparto"
          /> </v-col
      ></v-row>
      <v-row justify="center" v-if="selezione == 'profili'">
        <v-col cols="12" class="py-0"> <ProfiliCal /> </v-col
      ></v-row>
      <v-row justify="center" v-if="selezione == 'macchine'">
        <v-col cols="12" class="py-0"> <MacchineCal /> </v-col
      ></v-row>
      <v-row justify="center" v-if="selezione == 'sedi'">
        <v-col cols="12" class="py-0">
          <SediCal :id_azienda_sede="id_azienda_sede" /> </v-col
      ></v-row>
      <v-row justify="center" v-if="selezione == 'veicoli'">
        <v-col cols="12" class="py-0">
          <QLVeicoliCal :id_macchina="id_macchina" /> </v-col
      ></v-row>
      <v-row justify="center" v-if="selezione == 'autisti'">
        <v-col cols="12" class="py-0">
          <QLAutistiCal :id_conduttore="id_conduttore" /> </v-col
      ></v-row>
      <v-row justify="center" v-if="selezione == 'persone'">
        <v-col cols="12" class="py-0"> <PersoneCal /> </v-col
      ></v-row>
    </v-card-text>
    <!-- DIALOG NUOVO CALENDARIO -->
    <!-- <v-dialog v-model="dialog_nuovo_calendario" max-width="800px">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>Nuovo calendario - Ore al giorno</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="nuovoCalendario" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_nuovo_calendario = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-5">
          <v-row
            ><v-col cols="3">
              <v-autocomplete
                background-color="#ffffff"
                hide-details
                :items="lista_riferimenti"
                item-value=""
                label="Riferimento"
                style="display: inline-block; max-width: 350px"
                v-model="unita_riferimento"
              >
              </v-autocomplete>
            </v-col></v-row
          >
          <v-row
            ><v-col cols="2">
              <v-text-field
                v-model="ore_new.lunedi"
                type="number"
                label="Lunedì"
              >
              </v-text-field
            ></v-col>
            <v-col cols="2">
              <v-text-field
                v-model="ore_new.martedi"
                type="number"
                label="Martedì"
              >
              </v-text-field
            ></v-col>
            <v-col cols="2">
              <v-text-field
                v-model="ore_new.mercoledi"
                type="number"
                label="Mercoledì"
              >
              </v-text-field
            ></v-col>
            <v-col cols="2">
              <v-text-field
                v-model="ore_new.giovedi"
                type="number"
                label="Giovedì"
              >
              </v-text-field
            ></v-col>
            <v-col cols="2">
              <v-text-field
                v-model="ore_new.venerdi"
                type="number"
                label="Venerdì"
              >
              </v-text-field
            ></v-col>
            <v-col cols="2">
              <v-text-field
                v-model="ore_new.sabato"
                type="number"
                label="Sabato"
              >
              </v-text-field
            ></v-col>
            <v-col cols="2">
              <v-text-field
                v-model="ore_new.domenica"
                type="number"
                label="Domenica"
              >
              </v-text-field
            ></v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog> -->
  </v-container>
</template>
  
  <script>
import QLCalTreeview from "./QLCalendariTreeview.vue";
import PersoneCal from "@/components/PRODUCTION/Impostazioni/Calendario/PersoneCal.vue";
import QLAutistiCal from "./QLAutistiCal.vue";
import QLVeicoliCal from "./QLVeicoliCal";
import AziendaCal from "@/components/PRODUCTION/Impostazioni/Calendario/AziendaCal.vue";
import RepartiCal from "@/components/PRODUCTION/Impostazioni/Calendario/RepartiCal.vue";
import ProfiliCal from "@/components/PRODUCTION/Impostazioni/Calendario/ProfiliCal.vue";
import MacchineCal from "@/components/PRODUCTION/Impostazioni/Calendario/MacchineCal.vue";
import SediCal from "@/components/PRODUCTION/Impostazioni/Calendario/SediCal.vue";

export default {
  name: "QLCalendario",

  components: {
    PersoneCal,
    QLAutistiCal,
    QLCalTreeview,
    QLVeicoliCal,
    AziendaCal,
    RepartiCal,
    SediCal,
    ProfiliCal,
    MacchineCal,
  },

  props: {},

  data() {
    return {
      // Variabili d'appoggio
      selezione: "treeview",
      id_azienda_sede_reparto: null,
      id_azienda_sede: null,
      id_macchina: null,
      id_conduttore: null,
      ore_new: {
        lunedi: null,
        martedi: null,
        mercoledi: null,
        giovedi: null,
        venerdi: null,
        sabato: null,
        domenica: null,
      },
      unita_riferimento: "",

      // Modal
      // dialog_nuovo_calendario: false,

      // Array
      lista_calendari: new Array(),
      headers_cal: new Array(),
      lista_riferimenti: ["Azienda", "Sede", "Reparto"],
    };
  },

  computed: {},

  watch: {
    variabile: {
      immediate: true,

      handler() {},
    },
  },

  methods: {
    changeComponent(e) {
      console.log(e);
      switch (e.tipo) {
        case "sedi":
          this.id_azienda_sede = e.id;
          break;
        case "reparto":
          this.id_azienda_sede_reparto = e.id;

          break;
        case "veicoli":
          this.id_macchina = e.id;

          break;
        case "autisti":
          this.id_conduttore = e.id;

          break;
      }
      this.selezione = e.tipo;
    },
    getCalendari() {
      this.headers_cal = [
        {
          text: "Nome",
          value: "des_calendario",
        },
        {
          text: "Priorità",
          value: "priorita",
        },
        {
          text: "Lunedì",
          value: "lunedi_ore",
        },
        {
          text: "Martedì",
          value: "martedi_ore",
        },
        {
          text: "Mercoledì",
          value: "mercoledi_ore",
        },
        {
          text: "Giovedì",
          value: "giovedi_ore",
        },
        {
          text: "Venerdì",
          value: "venerdi_ore",
        },
        {
          text: "Sabato",
          value: "sabato_ore",
        },

        {
          text: "Domenica",
          value: "domenica_ore",
        },
        {
          text: "Giorni esclusi generici",
          value: "giorni_gen",
        },
        {
          text: "Giorni esclusi specifici",
          value: "giorni_spec",
        },
      ];

      const request = {
        controller: "Tools",
        method: "POST",
        richiesta: {
          action: "getcalendario",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.macchine_lista = [];
          res.data.calendario.forEach((e) => {
            this.lista_calendari.push(e);
          });
          console.log(res.data.calendario);
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });

      const requesttest = {
        controller: "Tools",
        method: "POST",
        richiesta: {
          action: "getdisponibilitamacchina",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store.dispatch("api", requesttest).then((res) => {
        if (res.status === 200) {
          console.log(res.data);
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },
  },

  created() {},

  mounted() {
    this.getCalendari();
  },
};
</script>
  
  <style scoped>
</style>